<template>
  <div>
    <span class="shipping-address-listings" style="width: 100px; display: block;" :title="shipping.description" v-if="shipping.description">D: {{shipping.description}}<br></span>
    <span class="shipping-address-listings" style="width: 100px; display: block;" :title="shipping.instructions" v-if="shipping.instructions">I: {{shipping.instructions}}</span>
    <span class="shipping-address-listings" style="width: 100px; display: block;" :title="shipping.itemsQuantity + ' item(s)'" v-if="ecosystemModules.items?.self && shipping.itemsToShow.length > 0">
      <a v-if="shipping.company" href="#" class="px-1" :class="shipping.itemsQuantity > 1 ? 'text-secondary' : ''" :style="shipping.itemsQuantity > 1 ? 'background: #ffc;' : ''" @click.prevent v-b-modal="'modalItems' + shipping.id" :translate-n="shipping.itemsQuantity" translate-plural="%{ itemsQuantity } items" v-translate="{itemsQuantity: shipping.itemsQuantity}">%{ itemsQuantity } item</a>
      <b-modal v-if="shipping.company" :id="'modalItems' + shipping.id" :ref="'modalItems' + shipping.id" hide-footer>
        <template #modal-title>
          <translate>Shipping Items</translate>
        </template>
        <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
        <shipping-items :shipping="shipping" @success="emitSuccess" />
      </b-modal>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ShippingsListItemInstructions',
  props: {
    shipping: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  methods: {
    emitSuccess() {
      this.$emit('success', true)
    }
  }
}
</script>
